export const formatResponseForAutocomplete = (response: any) => ({
    quotationValue: {
        code: response.value.value,
        name: response.value.label
    },
    value: response.value.value
})

export const formatSelectedOptionForAutocomplete = (option: any) => ({
    label: option.name,
    value: {
        value: option.code,
        label: option.name
    }
})